import type { Table } from '@tanstack/react-table'
import { useMemo } from 'react'
import type { BulkSelection } from './types'

/**
 * A table's row selection, as the bulk bar reads it. TanStack memoizes the selected row
 * model, so the rows keep their identity until the selection changes and the bar's own
 * memos stay put across unrelated renders.
 */
export function useTableBulkSelection<T>(table: Table<T>): BulkSelection<T> {
  const selectedRows = table.getSelectedRowModel().rows
  return useMemo(
    () => ({ rows: selectedRows.map((row) => row.original), clear: () => table.resetRowSelection() }),
    [selectedRows, table],
  )
}
